<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'forminItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formoutItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 2)" :key="'formo1Item' + i" :viewMode="c.viewMode || viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <div>
            <FormItem v-for="(c, i) in formCtrlOrder.slice(2, 4)" :key="'formo2Item' + i" :viewMode="c.viewMode || viewMode"
              :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
            <!-- 亏吨重量控件 -->
            <FormItem :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl" :options="kuitonCtrl.options"
              :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
          </div>

          <div>
            <FormItem v-for="(c, i) in formCtrlOrder.slice(4, 6)" :key="'formo3Item' + i" :viewMode="c.viewMode || viewMode"
              :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>

          <FormItem v-for="(c, i) in formCtrlOrder.slice(6)" :key="'formo4Item' + i" :viewMode="c.viewMode || viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="!viewMode" :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";

// let fromPath = ''

let BreadCrumb = [
  { name: "订单管理", path: "/order/nocontract" },
  { name: "普通订单", path: "/order/nocontract/hire" },
  { name: "雇佣订单添加" },
]

let breadcrumb = [
  ...BreadCrumb,
]

export default {
  name: "NonContractOrderDetail",
  mixins: [detailMixin, orderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb,
      form: {
        cprice: undefined,
        dprice: undefined,
        inton: undefined,
        unton: undefined,
        invoice: undefined,
        uninvoice: undefined,
      },
      rules: {
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        dprice: [
          { required: true, message: "请填写司机单价", trigger: "blur" },
        ],
        inton: [
          { required: true, validator: this.checkInTon, trigger: "blur" },
        ],
        unton: [
          { required: true, validator: this.checkUnTon, trigger: "blur" },
        ],
        invoice: [
          { required: true, message: "请上传装货单", trigger: "blur" },
        ],
        uninvoice: [
          { required: true, message: "请上传卸货单", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "订单编号",
          keyName: "order_num",
          err: "请填写订单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "承运人",
          keyName: "pcustomname",
          err: "请填写承运人",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "信息费",
          keyName: "cmessage",
          err: "请填写信息费",
          type: "text",
          viewMode: true,
        },
      ],
      kuitonCtrl: {
        label: "亏吨重量",
        keyName: "kuiton",
        err: "请填写亏吨重量",
        type: "text",
        viewMode: true,
      },
      formCtrlOrder: [
        {
          label: "公司单价（元/吨）",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
        },
        {
          label: "司机单价（元/吨）",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
        },
        {
          label: "装货重量（吨）",
          keyName: "inton",
          err: "请填写装货重量",
          type: "text",
        },
        {
          label: "卸货重量（吨）",
          keyName: "unton",
          err: "请填写卸货重量",
          type: "text",
        },
        {
          label: "装货单",
          keyName: "invoice",
          err: "请上传装货单",
          type: "file",
          tips: "图片大小最好不要超过2M",
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请上传卸货单",
          type: "file",
          className: "unton",
          tips: "图片大小最好不要超过2M",
        },
        {
          label: "亏吨单价（元/吨）",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
        },
      ],
      submitUrl: 'upunorder',
    };
  },
  methods: {},
  mounted() {
    // console.log(this.$route.path)
    if (this.$route.path === '/order/contractdetail') {
      this.formCtrlOrder.map(v => {
        if (v.keyName === 'cprice') {
          v.viewMode = true
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    // fromPath = from.path
    if (from.path.includes('/contract/hire')) {
      // 来自合同订单管理
      breadcrumb[0] = { name: "订单管理", path: "/order/contract" }
      breadcrumb[1] = { name: "合同订单", path: "/order/contract/hire" }
    } else {
      breadcrumb[0] = BreadCrumb[0]
      breadcrumb[1] = BreadCrumb[1]
    }
    next()
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
